import { Button, Card, Col, Form, Input, Modal, Row, Typography } from "antd";
import React, { useState } from "react";
import styles from "./Login.module.css";

import { useDispatch } from "react-redux";
import { addUser } from "../../redux/rtk/features/user/userSlice";

import axios from 'axios';
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const Login = () => {
	const dispatch = useDispatch();
	const [loader, setLoader] = useState(false);
	const [forgotPasswordVisible, setForgotPasswordVisible] = useState(false);
	const { Title } = Typography;
	

	const onFinish = async (values) => {
		const resp = await dispatch(addUser(values));
		if (resp.payload.message === "success") {
			setLoader(false);
			// localStorage.setItem('passwordChanged', !resp.payload.isDefaultPassword);
			window.location.href = "/admin/dashboard";
		} else {
			setLoader(false);
		}
	};

	// const checkEmail = async (values) => {
	// 	// Perform email-specific checks or actions here
	// 	const resp = await dispatch(getUserByEmail(values));
	// 	if (resp.status.code === 400) {
	// 		toast.error("Failed to send verification email. Please try again.")
	// 	} else {
	// 	    toast.success("Verification email sent!");
	// 	}
	// };

	const checkEmail = async (values) => {
		// setLoader(true); 
		console.log("hhhh", values)
		console.log("vvvv", values.email)
		try {
			// const response = await axios.post('/user/getUserByEmail', { email: values.email });
			const response = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `user/getUserByEmail`,
				data: {
					email: values.email,
				},
			});

			if (response.status === 200) {
				const userId = response.data;
				// setLoader(false);
				toast.success("A password reset email has been sent to your email address.");
				setForgotPasswordVisible(false);
			} else {
				toast.error("This E-Mail is not registered with us. Please try again.");
				// setLoader(false);
			}
		} catch (error) {
			toast.error("This E-Mail is not registered with us. Please try again.");
			console.error("Error fetching user by email:", error);
			// setLoader(false);
			// Handle error case
		}
		// finally {
		// 	setLoader(false); // Set the loader to false after the API call is complete
		//   }
	};

	const onFinishFailed = (errorInfo) => {
		console.log("Failed:", errorInfo);
		setLoader(false);
		toast.error("Error at login Please try again");
	};

	const handleForgotPassword = () => {
		setForgotPasswordVisible(true); // Open the forgot password modal
	};

	const handleForgotPasswordCancel = () => {
		setForgotPasswordVisible(false); // Close the forgot password modal
	};

	return (
		<>
			<Row className='card-row'>
				<Col span={24}>
					<Card bordered={false} className={styles.card}>
						<Title level={3} className='m-3 text-center'>
							Login
						</Title>
						<Form
							name='basic'
							labelCol={{
								span: 6,
							}}
							wrapperCol={{
								span: 16,
							}}
							onFinish={onFinish}
							onFinishFailed={onFinishFailed}
							autoComplete='off'>
							<Form.Item
								className='mb-5'
								label='Username'
								name='userName'
								rules={[
									{
										required: true,
										message: "Please input your userName!",
									},
								]}>
								<Input />
							</Form.Item>

							<Form.Item
								className='mb-5'
								label='Password'
								name='password'
								rules={[
									{
										required: true,
										message: "Please input your password!",
									},
								]}>
								<Input.Password />
							</Form.Item>

							<Form.Item className={styles.submitBtnContainer}>
								<Button
									type='primary'
									htmlType='submit'
									loading={loader}
									onClick={() => setLoader(true)}>
									Submit
								</Button>
							</Form.Item>
							{/* <div className="text-center mt-2">
								<Button type="link" onClick={handleForgotPassword}>
									Forgot Username or Password?
								</Button>
							</div> */}

							<h6 className="text-center mt-2">
								Don't have an account yet?{" "}
								<Link to={"/auth/registerClient"}>Sign up now</Link>
							</h6>

						</Form>
					</Card>
				</Col>
			</Row>
			<Modal
				title="Forgot Username or Password"
				visible={forgotPasswordVisible}
				onCancel={handleForgotPasswordCancel}
				footer={null}

			>
				<Form
					name="forgotPasswordForm"
					labelCol={{ span: 6 }}
					wrapperCol={{ span: 16 }}
					initialValues={{ remember: true }}
					onFinish={checkEmail}
				>
					<Form.Item
						label="Email"
						name="email"
						rules={[
							{
								required: true,
								message: "Please input your email!",
							},
							{
								type: "email",
								message: "Please enter a valid email address!",
							},
						]}
					>
						<Input />
					</Form.Item>
					<Form.Item wrapperCol={{ offset: 6, span: 16 }}>
						<Button type="primary" htmlType="submit">
							Submit
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</>
	);
};

export default Login;
